import { Component, OnInit, Inject, OnDestroy, ViewChildren, ViewChild, QueryList } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { ManagePermissionsContext } from '../models/ManagePermissionsContext';
import { Store } from '@ngrx/store';
import { Actions } from '@ngrx/effects';
import { Observable, Subject } from 'rxjs';

import * as fromStore from '../store/reducers';
import { QueryAvailablePermissionsAction, QUERY_AVAILABLE_PERMISSIONS_SUCCESS } from '../store/actions/index';
import { SearchComponent } from '../../pillar/search/components/search.component';
import { AlertsComponent } from '../../pillar/alerts/components/alerts.component';
import { SystemPermissionModel } from '../models/SystemPermissionModel';

@Component({
  selector: 'app-manage-permissions-dialog',
  templateUrl: './manage-permissions-dialog.component.html',
  styleUrls: ['./manage-permissions-dialog.component.scss']
})
export class ManagePermissionsDialogComponent implements OnInit, OnDestroy {
  destroyed$: Subject<boolean> = new Subject<boolean>();
  loadingAvailable: boolean;
  availablePermissions: SystemPermissionModel[];
  allPermissions: SystemPermissionModel[] = [];
  assignedPermissions: SystemPermissionModel[];
  allAssignedPermissions: SystemPermissionModel[] = [];
  showDetailsForAvailable = true;
  showDetailsForAssigned = true;

  @ViewChild(AlertsComponent)
  alert: AlertsComponent;

  @ViewChildren(SearchComponent)
  searchs: QueryList<SearchComponent>;

  constructor(public store: Store<any>,
    private actions$: Actions,
    public dialogRef: MatDialogRef<ManagePermissionsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ManagePermissionsContext) {
    this.loadingAvailable = true;
    store.dispatch(new QueryAvailablePermissionsAction({
      page: 0,
      pageSize: 100
    }));
  }

  ngOnDestroy() {
    this.destroyed$.next(true);
  }

  ngOnInit() {
    this.actions$
      .ofType(QUERY_AVAILABLE_PERMISSIONS_SUCCESS)
      .takeUntil(this.destroyed$)
      .subscribe(() => {
        this.loadingAvailable = false;
      });    
    this.store.select(fromStore.getPermissions)
      .takeUntil(this.destroyed$)
      .subscribe((permissions: SystemPermissionModel[]) => {
        this.allPermissions = permissions;
        this.updateAvailablePermissions();
      });
    this.data.assignedPermissions$
      .takeUntil(this.destroyed$)
      .subscribe((permissions: SystemPermissionModel[]) => {
        this.allAssignedPermissions = permissions;
        this.updateAssignedPermissions(null);
        this.updateAvailablePermissions();
      });
  }

  ngAfterViewInit() {
    this.searchs.first.searchControl.valueChanges
      .takeUntil(this.destroyed$)
      .subscribe(() => {
        this.loadingAvailable = true;
        this.store.dispatch(new QueryAvailablePermissionsAction({
          page: 0,
          pageSize: 100,
          searchTerm: this.searchs.first.searchControl.value
        }));
      });
    this.searchs.last.searchControl.valueChanges
      .takeUntil(this.destroyed$)
      .subscribe(() => {
        this.updateAssignedPermissions(this.searchs.last.searchControl.value);
      });
  }

  private updateAvailablePermissions(): void {
    if (this.allPermissions) {
      this.availablePermissions = this.allAssignedPermissions ? this.allPermissions.filter(r => this.allAssignedPermissions.find(ar => ar.key === r.key) == null) : this.allPermissions;
    } else {
      this.availablePermissions = undefined;
    }
  }

  private updateAssignedPermissions(searchTerm) {
    this.assignedPermissions = searchTerm ? this.allAssignedPermissions.filter(ar => ar.name.toLowerCase().includes(searchTerm.toLowerCase())) : this.allAssignedPermissions;
  }

  close() {
    this.dialogRef.close();
  }

  private removeThePermission(permission): void {
    if (this.allAssignedPermissions.length > 1) {
      this.data.removePermission(permission);
    } else {
      this.alert.addError("Cannot remove all permissions.");
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/security/components/manage-permissions-dialog.component.ts